var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seckill"},[_c('p',{staticClass:"seckill__title"},[_vm._v("秒杀模块")]),_c('p',{staticClass:"seckill__subtitle"},[_vm._v(" 一般放在轮播图下方，此模块无须预览，提供占位即可。 ")])])
}]

export { render, staticRenderFns }